export { useEditor } from "@tiptap/react";
export * from "./extensions/extension";
export * from "./components/StyledEditor";
